import { useTranslation } from "react-i18next";
import { LeftSocialMediaIconUI } from "../components/LeftSocialMediaIconUI";
import { RenderNavItem } from "../components/RenderNavItem";
import { CarParkingLeftMenuList } from "../utils/constants";

const Car_Parking_Home = () => {
  const { t } = useTranslation();
  return (
    <>
      <section id="hero" className="hero hero2">
        <LeftSocialMediaIconUI />

        <div className="carousel-item active">
          <img src="assets/img/inner-bg2.png" className="img-fluid" alt="alt" />
        </div>
      </section>
      {/* End Slider */}
      <section className="section inner-pad1">
        <div className="container">
          <div className="row">
            <div className="col-lg-3">
              <div className="site-menu min-height-400">
                <nav className="sidebar card py-2">
                  <ul className="nav flex-column" id="nav_accordion">
                    {CarParkingLeftMenuList.map((item, index) => (
                      <RenderNavItem item={item} index={index} t={t} />
                    ))}
                  </ul>
                </nav>
              </div>
            </div>
            <div className="col-lg-9">
              <div className="container">
                <div className="row">
                  <div className="inner-title2">
                    <h3 className="fontSizeClass"> {t("Car Parking")} :</h3>
                  </div>
                  <div className="col-lg-12 about-head1">
                    <div className="unit-area-assessment">
                      <br />
                      <p className="fontSizeClass">
                        {t(
                          "The Collector member shall have Authentic Identity Card and shall be endorsed by the Concerned Officer of K.M.C., otherwise the Identity Card shall be considered as invalid. Certified copy of the current Possession Certificate to be made available with the Collectors working at site"
                        )}
                        .
                      </p>
                      <p className="fontSizeClass">
                        {t(
                          "Parking fees can be realised on the schedule rate of K.M.C. as mentioned herein and are Permissible upto the validity period of license"
                        )}
                        .
                      </p>
                      <br />
                      &nbsp;
                      <p className="fontSizeClass">
                        {t(
                          "Anybody realising the Parking Fees beyond the validity period of license and validity period of the possession certificate will be treated as illegal and may be proceeded against the law. Realisation of parking fees without valid identity card is illegal"
                        )}
                        .
                      </p>
                      <br />
                      &nbsp;
                      <p className="fontSizeClass">
                        {t(
                          "Parking fees can be realised from those vehicles parked within the licensed area and which have been parked leaving 50’ from Crossing junction/ intersection of the road and keeping free from obstruction of any carriage way, garage, entance to any premises. If any parking is made and parking fees are realised from those cars parked beyond the above area will be considered illegal"
                        )}
                        .
                      </p>
                      <p className="fontSizeClass">
                        {t(
                          "The licensee shall not collect parking fees at a rate higher or lower than that approved by the Municipal Commissioner, K.M.C"
                        )}
                      </p>
                      <br />
                      &nbsp;
                      <p className="fontSizeClass">
                        {t(
                          "In the event of a compliant made against the licensee for collection of parking fees at a higher rate or for any violation of the terms and condition, K.M.C. shall have the right to enquire into the complaint and on being satisfied about the nature of the complaints, K.M.C shall also have the right to impose fine/penalty on the licensee as may be determined from time to time"
                        )}
                        .
                      </p>
                      <br />
                      &nbsp;
                      <p className="fontSizeClass">
                        {t(
                          "Other terms and conditions as already agreed and singed to be made available with all the Collector-Member at site"
                        )}
                        .
                      </p>
                      <br />
                      &nbsp;
                      <p className="alert-notice">
                        <strong>
                          {t(
                            " IN CASE OF ANY COMPLAINT AGAINST PARKING LICENSEE/AGENCY, PLEASE CONTACT AT TELEPHONE NO. 0332286-1000 (Extn.-2829) OR SEND WHATSAPP MESSAGE TO KOLKATA MUNICIPAL CORPORATION AT 8335999111 "
                          )}
                        </strong>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Car_Parking_Home;
